import { all, takeLatest } from "redux-saga/effects";

import { Types as ExpensesTypes } from "../ducks/expenses";

// Sagas
import { createExpense, deleteExpense } from "./expenses";

export default function* () {
    yield all([
        takeLatest(ExpensesTypes.CREATE_EXPENSE_REQUEST, createExpense),
        takeLatest(ExpensesTypes.DELETE_EXPENSE_REQUEST, deleteExpense),
    ]);
}
